// Google Analyticsの制御に関するユーティリティ関数

export const enableGoogleAnalytics = () => {
    // Google Analyticsを有効化
    if (typeof window !== 'undefined') {
        // Google Tag Managerを読み込み
        if (!window.dataLayer) {
            window.dataLayer = [];
        }

        // Google Tag Manager
        const gtmScript = document.createElement('script');
        gtmScript.async = true;
        gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-KMPCTG24';
        document.head.appendChild(gtmScript);

        // Google Analytics 4
        const ga4Script = document.createElement('script');
        ga4Script.async = true;
        ga4Script.src = 'https://www.googletagmanager.com/gtag/js?id=G-8QPHW81ZGC';
        document.head.appendChild(ga4Script);

        // Google Ads
        const adsScript = document.createElement('script');
        adsScript.async = true;
        adsScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17187238444';
        document.head.appendChild(adsScript);

        // gtag関数を設定
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };

        // 設定を適用
        window.gtag('js', new Date());
        window.gtag('config', 'G-8QPHW81ZGC');
        window.gtag('config', 'AW-17187238444');

        console.log('Google Analytics enabled');
    }
};

export const disableGoogleAnalytics = () => {
    // Google Analyticsを無効化
    if (typeof window !== 'undefined') {
        // Google Analyticsの無効化処理
        console.log('Google Analytics disabled');
    }
};

export const isGoogleAnalyticsEnabled = (): boolean => {
    const consent = localStorage.getItem('cookie_consent_status');
    return consent === 'accepted';
};

// Cookie同意状態をチェックする関数
export const checkCookieConsent = (): 'accepted' | 'declined' | 'pending' => {
    if (typeof window === 'undefined') return 'pending';

    const consent = localStorage.getItem('cookie_consent_status');
    if (consent === 'accepted' || consent === 'declined') {
        return consent;
    }
    return 'pending';
};
